import React, { useState, useRef, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import PropTypes from "prop-types";
import * as currentPageActions from "../../../../../store/actions/currentPageActions";
import M_TemplatePagesHeader from "../../../Molecules/Common/PageHeaders/TemplatePageHeader/M_TemplatePagesHeader";
import PageContext from "../../../../../contexts/pageContext";
import O_LayoutMenu from "../../../Organisms/Common/LayoutMenu/O_LayoutMenu";
import Layout from "../Layouts/layout";
import A_IconButton from "../../../Atoms/Inputs/Buttons/A_IconButton";
import PageNotFound from "../../../../../Routes/PageNotFound";
import * as manageExcelTemplateActions from "../../../../../store/actions/manageExcelTemplateActions";
import * as addToolbarFilterActions from "../../../../../store/actions/manageToolbarSelectionsActions";
import { SortedLayOuts } from "../../../../Factory/Molecules/Common/Navigations/LayoutMenu/LayoutMenu";
import { handleShowHide, templateToShow } from "./pageLayoutfunctions";
import {
  AddFilterToChartCard,
  clearChartKeys,
  pageTypes,
} from "./P_PageLayout.Helper";
import A_Snackbar from "../../../Atoms/Feedback/Snackbars/A_Snackbar";
import * as loggedInUserIdActions from "../../../../../store/actions/loggedInUserIdActions";
import * as toastActions from "../../../../../store/actions/toastActions";
import { toastType } from "../../../../../Utils/config/toastConfig";
import { pageConfig } from "../../../../../Utils/config/config";
import LoadingMessage from "../../../../Utils/Oidc/LoadingMessage/LoadingMessage";
import LoadingLayout from "../../../../Utils/Oidc/LoadingMessage/SkeletonLoading";
import { getObjectFromJSONString } from "../../../Molecules/Common/Navigations/AddEntity/M_ManageEntityForm.helper";
import { executeJSString } from "../Layouts/layout.Helper";
import { flushBreadCrumps } from "../../../Molecules/Common/PageHeaders/TemplatePageTitle/M_BreadCrumbs.helper";
import { portfolioapproval } from "../../../Molecules/Common/PageHeaders/Toolbar/M_ToolbarFilterhelper";
import { resetFiltersValue } from "../../../../../store/actions/manageFilterValueAction";
import { getCRMContactInfo } from "../../../../../Utils/Helpers/common";
import { getTheme } from "../../../../../Utils/Helpers/common";
import {
  getStoredSidebarOpen,
  applySidebarOpen,
} from "../../../Molecules/Common/Navigations/M_ThemeSelector/M_ThemeSelector.helper";

const useStyles = makeStyles((theme) => ({
  toggleButton: {
    zIndex: 1200,
    position: "fixed",
    bottom: 15,
    left: "243px",
    marginLeft: "-11px",
    width: 22,
    height: 22,
    borderRadius: "50%",
    backgroundColor: "var(--color-background-paper)",
    color: "var(--color-text-primary)",
    border: "1px solid var(--border-color)",
    padding: 0,
    minWidth: "auto",
    boxShadow:
      "0 2px 6px rgba(0, 0, 0, 0.08), 0 0 0 4px var(--color-background-default)",
    transition:
      "left 320ms cubic-bezier(0.4, 0, 0.2, 1), transform 220ms cubic-bezier(0.4, 0, 0.2, 1), background-color 180ms ease, border-color 180ms ease, box-shadow 180ms ease",
    "&:hover": {
      backgroundColor: "var(--color-primary-main)",
      borderColor: "var(--color-primary-main)",
      transform: "scale(1.1)",
      boxShadow:
        "0 4px 12px rgba(0, 0, 0, 0.18), 0 0 0 4px var(--color-background-default)",
      "& svg": {
        color: "var(--color-primary-contrast) !important",
      },
    },
    "& svg": {
      fontSize: "0.875rem",
      transition: "transform 320ms cubic-bezier(0.4, 0, 0.2, 1), color 180ms ease",
      color: "var(--color-text-secondary)",
    },
    [theme.breakpoints.down("sm")]: {
      left: "243px",
      // On mobile the toggle sits at the top (just below the 64px navbar)
      // instead of the bottom corner.
      bottom: "auto",
      top: 110,
    },
  },
  toggleButtonCollapsed: {
    left: "var(--rail-w, 68px) !important",
    "& svg": {
      transform: "rotate(180deg)",
    },
    "&:hover svg": {
      transform: "rotate(180deg) scale(1)",
    },
    [theme.breakpoints.down("sm")]: {
      left: "8px !important",
      marginLeft: "0 !important",
    },
  },
}));

const P_PageLayout = (props) => {
  let { pageUrl, crmId, templateId } = useParams();
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  // Default the rail toggle ON. Tenants whose /ColourScheme payload has no
  // `sideBar` block (e.g. lms-demo) still get it; only an explicit
  // `ShowSideBarToggle: false` opts out, which keeps it mobile-only.
  const ShowSideBarToggle = getTheme()?.sideBar?.ShowSideBarToggle !== false;

  const layoutselection = useRef(null);
  const [currentPage, setCurrentPage] = useState(undefined);
  const [layout, setLayout] = useState([]);
  const [viewOnlyLayouts, setViewOnlyLayouts] = useState([]);
  const [pageTitle, setPageTitle] = useState("");
  const [pageSubtitle, setPageSubtitle] = useState("");
  const [manualRefresh, setManualRefresh] = useState("");
  const [currentPageId, setCurrentPageId] = useState("");
  const [crmDataForShow, setCrmDataForShow] = useState([]);
  const [apiError, setApiError] = useState(false);
  const [isExcelTemplateDownload, setIsExcelTemplateDownload] = useState(false);
  const [toastStatus, setToastStatus] = useState(false);
  const [marginTop, setMarginTop] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(getStoredSidebarOpen);
  const isRailCollapsed = !isSidebarOpen && !isMobile;

  // eslint-disable-next-line no-use-before-define, no-unused-vars
  const [currentPathName, setCurrentPathName] = useState(
    localStorage.getItem(portfolioapproval.CURRENTPATHNAME)
      ? localStorage.getItem(portfolioapproval.CURRENTPATHNAME)
      : ""
  );
  const { crmContactUserId, isMinervaUser, isEA } = getCRMContactInfo();
  const userid = useSelector((state) =>
    state?.getLoggedInUserReducer?.data?.[0]?.id
      ? state.getLoggedInUserReducer.data[0].id
      : crmContactUserId
  );

  window.onpopstate = function () {
    window.location.reload();
    flushBreadCrumps();
  };

  const resetToast = () => {
    setToastStatus(false);
    props.setToast({});
  };

  useEffect(() => {
    if (isMobile) {
      const saved = localStorage.getItem("sidebarOpen");
      const isOpened = saved !== null ? JSON.parse(saved) : true;
      setIsSidebarOpen(isOpened);
    }
  }, [isMobile]);

  useEffect(() => {
    var pathname = window.location.pathname;
    var parts = pathname.split("/");
    if (parts.length > 1) {
      if (currentPathName !== parts[1] && currentPathName !== "") {
        dispatch(resetFiltersValue());
      } else localStorage.removeItem("chartStorageKeys");
      localStorage.setItem(portfolioapproval.CURRENTPATHNAME, parts[1]);
    }
  }, [currentPathName]);

  useEffect(() => {
    props.resetToolbarFilters();
    props.setTabs(null);
    props.currentPage.isLoading = true;
    props.getCurrentPage({ pageUrl, crmId });
    clearChartKeys();
    resetToast();
  }, []);

  const handleSnackbarClose = () => {
    setToastStatus(false);
    resetToast();
  };

  useEffect(() => {
    if (props.toast && props.toast.message && props.toast.message !== "") {
      setToastStatus(true);
    }
    //TODO - edge logic to be excluded from page logic
    //TODO -Changing deal team will not impact rest of the component, that should be loaded
    //asynchrounously
    //TODO -Current implementation is just a patch.
    //TODO - props.toast.type === toastType.DELETE_EDGE this is deal team specific, which should not call complete page stuff only getEdge api
    if (
      props.toast.type === toastType.CRM_FORM_UPDATE ||
      props.toast.type === toastType.DELETE_EDGE ||
      props.toast.type === toastType.DELETE_RECORD
    ) {
      if (
        layout?.templateJson?.cards[0]?.content?.content?.content?.type ===
        pageTypes.LENDERS_APPROACHED
      ) {
        setManualRefresh(parseInt(Math.random() * 1000000000, 10));
      } else {
        setTimeout(() => {
          props.getCurrentPage({ pageUrl, crmId });
        }, 500);
      }
    }
  }, [props.toast && props.toast.type]);

  // Current page management
  useEffect(() => {
    //set Active layout
    if (props.currentPage) {
      //resetToast();
      if (
        props.currentPage.templates &&
        props.currentPage.templates.length > 0
      ) {
        setApiError(false);
        let vwOnlyLayouts = templateToShow(props.currentPage);
        vwOnlyLayouts.reverse();
        vwOnlyLayouts = SortedLayOuts(vwOnlyLayouts);
        var currTemplate =
          templateId == undefined
            ? vwOnlyLayouts[0]
            : vwOnlyLayouts.filter((layOut) => {
                return layOut.id == templateId;
              })[0]
            ? vwOnlyLayouts.filter((layOut) => {
                return layOut.id == templateId;
              })[0]
            : vwOnlyLayouts[0];
        if (currTemplate) {
          let currTemplateJson =
            typeof currTemplate.templateJson === pageTypes.STRING &&
            currTemplate.templateJson.length > 0
              ? JSON.parse(currTemplate.templateJson)
              : currTemplate.templateJson;
          currTemplate.templateJson = currTemplateJson;
          if (props.currentPage && props.currentPage.isLoading === undefined) {
            history.push("/" + pageUrl + "/" + crmId + "/" + currTemplate.id);
          } else if (
            templateId == undefined ||
            templateId !== currTemplate.id
          ) {
            if (props.currentPage.isLoading) {
              return;
            }
            history.push("/" + pageUrl + "/" + crmId + "/" + currTemplate.id);
          }
          setLayout(AddFilterToChartCard(currTemplate, props.currentPage));
          setPageSubtitle(currTemplate.templateJson.title);
          setCurrentPageId(currTemplate.id);
          setViewOnlyLayouts(vwOnlyLayouts);
        } else {
          setLayout(null);
          setApiError(true);
        }
      }
      //set page title
      const getTitle = (headerTitle) => {
        try {
          var titleHeader = JSON.parse(headerTitle);
          return titleHeader?.[0]?.title ? titleHeader[0].title : headerTitle;
        } catch (e) {
          return headerTitle;
        }
      };
      if (
        props.currentPage.pageConfig &&
        props.currentPage.pageConfig.type === pageTypes.CRM //TODO - Change text comparision with id comparision
      ) {
        let fields = props.currentPage.pageConfig.fields;
        let titleFieldArry = fields.filter((field) => {
          return field.isPageTitle;
        });

        let concatTitle = "";
        for (let count = 0; count < titleFieldArry.length; count++) {
          if (
            props.currentPage.data &&
            props.currentPage.data[titleFieldArry[count].name] !== undefined
          ) {
            concatTitle = concatTitle.concat(
              getTitle(props.currentPage.data[titleFieldArry[count].name]) + " "
            );
          }
        }
        setPageTitle(concatTitle);
        setCrmDataForShow(props.currentPage.data);
      } else if (
        props.currentPage.pageConfig &&
        props.currentPage.pageConfig.type === pageConfig.NonCRM
      ) {
        setPageTitle(props.currentPage.pageConfig.name);
      }
    } else {
      setLayout([]);
    }
    setCurrentPage(props.currentPage);
    return () => {
      setCurrentPage(null);
    };
  }, [props.currentPage]);

  useEffect(() => {
    if (
      !props.currentPage.getCurrentPageSucceeded &&
      !props.currentPage.isLoading
    ) {
      setApiError(true);
    }
  }, [props.currentPage.getCurrentPageSucceeded, props.currentPage.isLoading]);

  useEffect(() => {
    props.getCurrentPage({ pageUrl, crmId });
  }, [pageUrl, crmId]);

  let newPageConfig = props.currentPage && props.currentPage.pageConfig;
  if (newPageConfig) {
    newPageConfig.subtitle = pageTypes.SUBTITLE;
  }

  function handleLayoutMenu(val) {
    if (isMobile) {
      setIsSidebarOpen(false);
    }
    if (val !== undefined) {
      let jsonLayout =
        typeof val.templateJson === pageTypes.STRING
          ? JSON.parse(val.templateJson)
          : val.templateJson;
      val.templateJson = jsonLayout;
      if (jsonLayout && jsonLayout.redirectTo && jsonLayout.redirectTo !== "") {
        if (jsonLayout.openInNewTab) {
          window.open(jsonLayout.redirectTo, "_blank", "noopener,noreferrer");
        } else {
          window.location.href = jsonLayout.redirectTo;
        }
      } else {
        setLayout(null);
        history.push("/" + pageUrl + "/" + crmId + "/" + val.id);
        clearChartKeys();
        setTimeout(() => {
          setLayout(AddFilterToChartCard({ ...val }, props.currentPage));
        }, 100);
        setPageSubtitle(val.templateJson.title);
        setCurrentPageId(val.id);
      }
    }
  }

  const downloadExcelTemplatePopUp = (value) => {
    switch (value) {
      case pageTypes.EXCELTEMPLATE_DOWNLOAD:
        setIsExcelTemplateDownload(true);
        break;
      default:
        break;
    }
  };

  const handleClosePopup = (value) => {
    switch (value) {
      case pageTypes.EXCELTEMPLATE_DOWNLOAD:
        setIsExcelTemplateDownload(false);
        break;
      default:
        break;
    }
  };
  const reloadPage = () => props.getCurrentPage({ pageUrl, crmId });
  const toggleSidebar = () => {
    setIsSidebarOpen((prevState) => {
      const newState = !prevState;
      applySidebarOpen(newState);
      return newState;
    });
  };

  useEffect(() => {
    const syncSidebarOpen = () => setIsSidebarOpen(getStoredSidebarOpen());
    window.addEventListener("themeChange", syncSidebarOpen);
    return () => window.removeEventListener("themeChange", syncSidebarOpen);
  }, []);

  useEffect(() => {
    if (!isMobile || !isSidebarOpen) return;
    const handleOutsideClick = (event) => {
      if (
        layoutselection.current &&
        !layoutselection.current.contains(event.target) &&
        !event.target.closest(`.${classes.toggleButton}`)
      ) {
        setIsSidebarOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isMobile, isSidebarOpen, classes.toggleButton]);

  return (
    <PageContext.Provider
      value={{
        pageConfig: currentPage && newPageConfig,
        crmData: props.currentPage && props.currentPage.data,
        pageParameters: [],
      }}
    >
      {apiError && <PageNotFound />}
      {currentPage && !apiError ? (
        <main className={isRailCollapsed ? "layout--rail" : "layout--pinned"}>
          {!currentPage.isLoading &&
            (ShowSideBarToggle === true ||
              (ShowSideBarToggle === false && isMobile)) && (
              <A_IconButton
                icon={<ChevronLeftIcon />}
                className={`${classes.toggleButton} ${
                  !isSidebarOpen ? classes.toggleButtonCollapsed : ""
                }`}
                onClick={toggleSidebar}
              />
            )}
          <>
            {!currentPage.isLoading && (
              <article className="page-header">
                <M_TemplatePagesHeader
                  title={pageTitle}
                  subtitle={pageSubtitle}
                  downloadExcelTemplatePopUp={downloadExcelTemplatePopUp}
                  onReload={reloadPage}
                  callback={(margin) => setMarginTop(margin)}
                  isSidebarOpen={isSidebarOpen}
                  readOnlyTemplate={executeJSString(
                    getObjectFromJSONString(
                      layout,
                      ".templateJson.readOnlyTemplate"
                    ),
                    getObjectFromJSONString(props, ".currentPage.data")
                  )}
                />
              </article>
            )}

            {currentPage &&
              currentPage.templates &&
              currentPage.templates.length > 0 && (
                <article
                  className={`page-sidebar ${
                    !isSidebarOpen
                      ? isMobile
                        ? "collapsed"
                        : "page-sidebar--rail"
                      : ""
                  }`}
                  ref={layoutselection}
                >
                  <O_LayoutMenu
                    data={viewOnlyLayouts}
                    currentLayoutTitle={
                      layout && layout.templateJson && layout.name
                    }
                    callbackParent={(val) => handleLayoutMenu(val)}
                    currentPageId={currentPageId}
                    isRailMode={isRailCollapsed}
                  />
                </article>
              )}
            <article
              className={`page-content ${!isSidebarOpen ? "expanded" : ""}`}
              style={
                !isMobile && marginTop && !currentPage.isLoading
                  ? { marginTop: marginTop }
                  : { marginTop: "10px" }
              }
            >
              {!currentPage.isLoading ? (
                <Layout
                  manualRefresh={manualRefresh}
                  templateSecurity = {layout?.templateSecurityUI}
                  cards={
                    layout &&
                    layout.templateJson &&
                    handleShowHide(layout.templateJson.cards, crmDataForShow)
                  }
                  isPrivateTemplate={
                    layout &&
                    layout.templateJson &&
                    layout.templateJson.isPrivate
                  }
                  userid={userid}
                  isMinervaUser={isMinervaUser}
                  isEA={isEA}
                  getCurrentPage={props.getCurrentPage}
                  data={props.currentPage.data}
                  handleClosePopup={handleClosePopup}
                  isExcelTemplateDownload={isExcelTemplateDownload}
                  params={{ pageUrl, crmId, templateId }}
                  readOnlyTemplate={executeJSString(
                    getObjectFromJSONString(
                      layout,
                      ".templateJson.readOnlyTemplate"
                    ),
                    getObjectFromJSONString(props, ".currentPage.data")
                  )}
                />
              ) : (
                <div style={{ marginLeft: "20px" }}>
                  <LoadingLayout />
                </div>
              )}
            </article>
            <article className="page-toast">
              {toastStatus && props.toast && props.toast.message && (
                <A_Snackbar
                  open={toastStatus}
                  message={props.toast.message}
                  type={props.toast.severity}
                  autoHideDuration={
                    props.toast.duration ? props.toast.duration : 2000
                  }
                  vertical={props.toast.vertical || "bottom"}
                  horizontal={props?.toast?.horizontal || "center"}
                  handleClose={handleSnackbarClose}
                  isHtml={props.toast.isHtml ? props.toast.isHtml : false}
                />
              )}
            </article>
          </>
        </main>
      ) : !apiError ? (
        <LoadingMessage />
      ) : null}
    </PageContext.Provider>
  );
};

function mapStateToProps(state) {
  return {
    manageExcelTemplates: state.manageExcelTemplates,
    currentPage: state.currentPage,
    loggedIn: state.getLoggedInUserReducer,
    toast: state.toast,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    Object.assign(
      {},
      currentPageActions,
      manageExcelTemplateActions,
      addToolbarFilterActions,
      loggedInUserIdActions,
      toastActions
    ),
    dispatch
  );
}

P_PageLayout.defaultProps = {
  currentPage: {},
  loggedIn: {},
};

P_PageLayout.propTypes = {
  resetToolbarFilters: PropTypes.func,
  setTabs: PropTypes.func,
  currentPage: PropTypes.object,
  getCurrentPage: PropTypes.func,
  getLoggedInUser: PropTypes.func,
  loggedIn: PropTypes.object,
  toast: PropTypes.object,
  setToast: PropTypes.any,
  readOnlyTemplate: PropTypes.any,
  callback: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(P_PageLayout);
